import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { assertComponentContext } from '../helpers';

export interface FormActionArgs {
  name: string;
  reset?: boolean;
}

export class FormAction extends ba.Action<FormActionArgs, any> {
  static get manifest() {
    return {
      name: 'form',
      schema: z.object({
        name: z.string(),
        reset: z.boolean().optional()
      })
    };
  }

  async handle(event: ba.ActionEvent, args: FormActionArgs) {
    const component = event.component;
    assertComponentContext(component);
    const form = component.forms[args.name];
    if (form && args.reset) {
      form.reset();
    }
  }
}
